import Client from "../client";
import PermissionDescriptionResource from "../resources/permissionDescriptionResource";

class PermissionDescriptionRepository  {
    private client: Client;
    constructor(client: Client) {
        this.client = client;
    }
    all(): Promise<PermissionDescriptionResource> {
        return this.client.get(this.client.getRootDocument().Links["PermissionDescriptions"], null);
    }
}

export default PermissionDescriptionRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/permissionDescriptionRepository.ts